export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const IFRAME_DATA = 'IFRAME_DATA'
export const PAYMENT_DATA = 'PAYMENT_DATA'
export const SINGLE_PAYEE = 'SINGLE_PAYEE'
